module.exports = __webpack_public_path__ + "img/鹿茸.5b9c54e1.jpg";